import { MenuItem, styled, Typography } from '@mui/material';

import { muiPalette } from '@/shared/general-theme';

interface StyledMenuItemTextProps {
  isRedText?: boolean;
}

export const StyledMenuItemText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isRedText',
})<StyledMenuItemTextProps>`
    color: ${props => props.isRedText ? muiPalette.error.main : muiPalette.text.primary};
`;

export const StyledMenuItem = styled(MenuItem)`
    padding: 0.75rem 1rem;
    align-items: center;

    &.Mui-disabled {
        opacity: 0.5;
    }
`;